module.exports = __webpack_public_path__ + "img/最高人气.ad1fa838.png";